import React, { useCallback } from "react";
import { injectIntl } from "react-intl";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";

const queryString = `
  query Partners {
    partners {
      id
      name
    }
  }
`;

const PartnerSelect = ({ id = "ownedByPartnerId", name = "ownedByPartnerId", onChange, intl, ...props }) => {
  const handleDataFromResponse = useCallback(data => data.partners, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => element.name, []);

  return (
    <EntitiesSelector
      id={id}
      name={name}
      emptyValue={null}
      emptyValueText={intl.formatMessage({ id: "common.none" })}
      queryString={queryString}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      onChange={onChange}
      {...props}
    />
  );
};

PartnerSelect.propTypes = {
  ...commonPropTypes,
};

export default injectIntl(PartnerSelect);
